import { render } from "./MarkGreen.vue?vue&type=template&id=4b1f6818"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MarkGreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b1f6818"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b1f6818', __exports__)) {
    api.reload('4b1f6818', __exports__)
  }
  
  module.hot.accept("./MarkGreen.vue?vue&type=template&id=4b1f6818", () => {
    api.rerender('4b1f6818', render)
  })

}


export default __exports__